document.addEventListener('DOMContentLoaded', function () {
  const cartBlocks = document.querySelector('.cart__blocks-inner');
  if (!cartBlocks) return;

  // .sns-gift-new-cart-container の処理
  function processSnsGiftContainer(container) {
    const locale = document.documentElement.lang || '';
    const isJapanese = locale.startsWith('ja');

    // TreeWalkerを使用してテキストノードのみを処理
    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    while (node = walker.nextNode()) {
      if (node.textContent.includes('//')) {
        const parts = node.textContent.split('//');
        const newContent = isJapanese ? parts[0] : parts.slice(1).join('//');
        node.textContent = newContent;
      }
    }
  }

  const snsGiftContainer = document.querySelector('.sns-gift-new-cart-container');
  if (snsGiftContainer) {
    processSnsGiftContainer(snsGiftContainer);
  }

  // 動的に追加される場合に対応するため、MutationObserverで監視
  const snsGiftObserver = new MutationObserver(function () {
    const snsGiftContainer = document.querySelector('.sns-gift-new-cart-container');
    if (snsGiftContainer) {
      processSnsGiftContainer(snsGiftContainer);
    }
  });

  snsGiftObserver.observe(cartBlocks, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  // 要素のheightを調整する関数
  function adjustHeight(element) {
    const computedStyle = window.getComputedStyle(element);

    if (computedStyle.visibility === 'hidden') {
      element.style.height = '0';
      element.style.overflow = 'hidden';
      element.style.margin = '0';
      element.style.padding = '0';
    } else if (computedStyle.visibility === 'visible') {
      element.style.height = '';
      element.style.overflow = '';
      element.style.margin = '';
      element.style.padding = '';
    }
  }

  // MutationObserverで子要素のstyle変更を監視
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        const target = mutation.target;

        // 対象要素のheightを調整
        adjustHeight(target);

        // cart__checkout-buttonの場合は親要素(.cart__ctas)も調整
        if (target.classList.contains('cart__checkout-button')) {
          const parent = target.closest('.cart__ctas');
          if (parent) {
            adjustHeight(parent);
          }
        }
      }
    });
  });

  // cart__blocks内の直接の子要素を監視
  const config = {
    attributes: true,
    attributeFilter: ['style'],
    subtree: true,
  };

  observer.observe(cartBlocks, config);
});
